export enum LayoutVariant {
  mobile,
  laptop,
  kiosk
}
